export const asStringArray = (value) => Array.isArray(value) ? value.filter((item) => typeof item === 'string') : [];
export const asSubsections = (value) => {
    if (!Array.isArray(value)) {
        return [];
    }
    return value.filter((item) => typeof item === 'object' && item !== null && !Array.isArray(item));
};
